export const valoresExibidosOffCanvasContratos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const headersPautas = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Ano', width: 7, key: 'ano' },
  { text: 'Status', width: 8, key: 'statusPauta' },
  { text: 'N Produtos', width: 22, key: 'produtosPauta' },
  { text: 'Descrição', width: 60, key: 'descricaoPauta' },
];

export const fieldObjectContratos = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
